module.exports = __webpack_public_path__ + "img/edit.0b5c7d3d.svg";